import React, { FC } from "react";
import { Table } from "../../components/Table";
import { ContentLayout } from "../../components/ContentLayout";
import { PAGINATION_PAGE_SIZE } from "../../configs";
import { PrivateRouteProps } from "../../types";
import { useFulfillers } from "../../hooks/useFulfilers";
import { useHistory } from "react-router-dom";
import { SearchBar } from "../../components/SearchBar";

const columns = [
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Address",
    dataIndex: "address",
  },
  {
    title: "Total inventory",
    dataIndex: "inventory",
  },
  {
    title: "Total SKUs",
    dataIndex: "total_sku",
  },
  {
    title: "Unshipped",
    dataIndex: "unshipped_orders",
  },
];

export const Fulfillers: FC<PrivateRouteProps> = ({ isAdmin }) => {
  const history = useHistory();
  const { items, count, nextPage, previousPage, search, isLoading } = useFulfillers();

  const onSelect = (row: any) => {
    history.push(`/dashboard/fulfillers/${row.id}`);
  };

  return (
    <ContentLayout title="Fulfillers">
      <div
        style={{ backgroundColor: "white", borderRadius: 16 }}
        className="px-3 py-5"
      >
        <SearchBar
          col={{ xs: 24, md: 12, lg: 8 }}
          placeholder="Search Fulfiller"
          onChange={(e: any) => search(e.target.value)}
        />
        <Table
          total={count}
          pageSize={PAGINATION_PAGE_SIZE}
          onNextPage={nextPage}
          onPreviousPage={previousPage}
          columns={columns}
          dataSource={items}
          loading={isLoading}
          onRow={(record, rowIndex) => ({
            onClick: (e) => onSelect(record),
          })}
        />
      </div>
    </ContentLayout>
  );
};
